import { StateCreator } from 'zustand';
import type { BetaDisclaimer, User } from '@/types/api';

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  /** Beta disclaimer gate state + copy, hydrated from the login/me payloads. */
  betaDisclaimer: BetaDisclaimer | null;
}

export interface AuthActions {
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  login: (user: User, token: string) => void;
  logout: () => void;
  setLoading: (isLoading: boolean) => void;
  setBetaDisclaimer: (betaDisclaimer: BetaDisclaimer | null) => void;
}

export type AuthSlice = {
  auth: AuthState & AuthActions;
};

const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: true,
  betaDisclaimer: null,
};

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  auth: {
    ...initialState,

    setUser: (user) =>
      set((state) => ({
        auth: { ...state.auth, user, isAuthenticated: !!user },
      })),

    setToken: (token) =>
      set((state) => ({
        auth: { ...state.auth, token, isAuthenticated: !!token },
      })),

    login: (user, token) =>
      set((state) => ({
        auth: { ...state.auth, user, token, isAuthenticated: true, isLoading: false },
      })),

    logout: () =>
      set((state) => ({
        auth: { ...state.auth, ...initialState },
      })),

    setLoading: (isLoading) =>
      set((state) => ({
        auth: { ...state.auth, isLoading },
      })),

    setBetaDisclaimer: (betaDisclaimer) =>
      set((state) => ({
        auth: { ...state.auth, betaDisclaimer },
      })),
  },
});
